export const T_LOADING = 'vs::loading';
